module.exports = __webpack_public_path__ + "media/images/shopping-cart-bg-a02c4eba0e4217bf7f1ed285903ce721.png";